import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';

export function getSystemSetting() {
  const res = MacleJSBridge.invokeSync(APINames.Native.GET_SYSTEM_SETTING);
  return res && JSON.parse(res);
}
